var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"loading_main"}},[_c('img',{attrs:{"id":"loading_icon","src":require("../assets/lloading.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }